// src/game/scenes/MenuScene.ts
import Phaser from "phaser";

export class MenuScene extends Phaser.Scene {
  private startText!: Phaser.GameObjects.Text;
  private titleText!: Phaser.GameObjects.Text;
  private instructionText!: Phaser.GameObjects.Text;

  constructor() {
    super({ key: "MenuScene" });
  }

  preload(): void {
    // Create simple colored rectangles as placeholder sprites
    this.createPlaceholderSprites();

    // Later, you'll replace these with actual asset loading:
    // this.load.spritesheet('player1', 'assets/sprites/player1.png', { frameWidth: 32, frameHeight: 48 });
    // this.load.image('platform', 'assets/sprites/platform.png');
  }

  create(): void {
    const centerX = this.cameras.main.centerX;
    const centerY = this.cameras.main.centerY;

    // Create title
    this.titleText = this.add
      .text(centerX, centerY - 150, "PICO BIT", {
        fontSize: "48px",
        color: "#ffffff",
        fontStyle: "bold",
        stroke: "#000000",
        strokeThickness: 4,
      })
      .setOrigin(0.5);

    // Create subtitle
    this.add
      .text(centerX, centerY - 100, "Cooperative Puzzle Platformer", {
        fontSize: "20px",
        color: "#ffffff",
        stroke: "#000000",
        strokeThickness: 2,
      })
      .setOrigin(0.5);

    // Create start button text
    this.startText = this.add
      .text(centerX, centerY + 50, "PRESS SPACE TO START", {
        fontSize: "24px",
        color: "#00ff00",
        fontStyle: "bold",
      })
      .setOrigin(0.5);

    // Create instructions
    const isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      ) || window.innerWidth < 768;

    const instructionText = isMobile
      ? "Touch the on-screen controls to move!\n\nPlayer 1 (Blue): Left D-pad\nPlayer 2 (Red): Right controls\n\nWork together to solve puzzles!"
      : "PLAYER 1: Arrow Keys\nPLAYER 2: WASD\n\nWork together to solve puzzles!";

    this.instructionText = this.add
      .text(centerX, centerY + 150, instructionText, {
        fontSize: "16px",
        color: "#ffffff",
        align: "center",
        stroke: "#000000",
        strokeThickness: 1,
      })
      .setOrigin(0.5);

    // Add blinking animation to start text
    this.tweens.add({
      targets: this.startText,
      alpha: 0,
      duration: 1000,
      yoyo: true,
      repeat: -1,
    });

    // Add floating animation to title
    this.tweens.add({
      targets: this.titleText,
      y: this.titleText.y - 10,
      duration: 2000,
      yoyo: true,
      repeat: -1,
      ease: "Sine.easeInOut",
    });

    // Handle input
    this.input.keyboard?.on("keydown-SPACE", () => {
      this.startGame();
    });

    // Add click/touch to start as well
    this.input.on("pointerdown", () => {
      this.startGame();
    });

    // Make the start text interactive
    this.startText.setInteractive();
    this.startText.on("pointerdown", () => {
      this.startGame();
    });

    // Add touch-friendly styling
    this.startText.on("pointerover", () => {
      this.startText.setStyle({ color: "#ffff00" });
    });

    this.startText.on("pointerout", () => {
      this.startText.setStyle({ color: "#00ff00" });
    });
  }

  private startGame(): void {
    // Transition to game scene
    this.cameras.main.fadeOut(500, 0, 0, 0);

    this.cameras.main.once("camerafadeoutcomplete", () => {
      this.scene.start("GameScene");
    });
  }

  private createPlaceholderSprites(): void {
    // Create simple colored rectangles for testing
    // Player 1 (blue rectangle)
    this.add
      .graphics()
      .fillStyle(0x0099ff)
      .fillRect(0, 0, 32, 48)
      .generateTexture("player1", 32, 48);

    // Player 2 (red rectangle)
    this.add
      .graphics()
      .fillStyle(0xff3300)
      .fillRect(0, 0, 32, 48)
      .generateTexture("player2", 32, 48);

    // Platform (gray rectangle)
    this.add
      .graphics()
      .fillStyle(0x666666)
      .fillRect(0, 0, 64, 32)
      .generateTexture("platform", 64, 32);

    // Background
    this.add
      .graphics()
      .fillGradientStyle(0x87ceeb, 0x87ceeb, 0x90ee90, 0x90ee90)
      .fillRect(0, 0, 800, 600)
      .generateTexture("background", 800, 600);
  }
}
